module.exports = __webpack_public_path__ + "img/homepageImg.b79ab9f9.png";